module.exports = __webpack_public_path__ + "static/media/Boot.52153ce9.mp3";